import LocaleStrings from "Languages";

export default function () {
  return [
    {
      iconName: "dashboard",
      section: "ticket",
      title: LocaleStrings.ticket_submenu_title1,
      description: LocaleStrings.ticket_submenu_description1,
    },
    {
      iconName: "appusers",
      section: "user",
      title: LocaleStrings.ticket_submenu_title8,
      description: LocaleStrings.ticket_submenu_description8,
    },
    {
      iconName: "formbuilder",
      section: "user",
      title: LocaleStrings.ticket_submenu_title7,
      description: LocaleStrings.ticket_submenu_description7,
    },
    {
      iconName: "badgedesign",
      section: "user",
      title: LocaleStrings.ticket_submenu_title11,
      description: LocaleStrings.ticket_submenu_description11,
    },
    {
      iconName: "managetickets",
      section: "ticket",
      title: LocaleStrings.ticket_submenu_title2,
      description: LocaleStrings.ticket_submenu_description2,
    },
    {
      iconName: "coupons",
      section: "ticket",
      title: LocaleStrings.ticket_submenu_title3,
      description: LocaleStrings.ticket_submenu_description3,
    },
    {
      iconName: "salesreport",
      section: "ticket",
      title: LocaleStrings.ticket_submenu_title4,
      description: LocaleStrings.ticket_submenu_description4,
    },
    {
      iconName: "payout",
      section: "ticket",
      title: LocaleStrings.ticket_submenu_title5,
      description: LocaleStrings.ticket_submenu_description5,
    },
    {
      iconName: "settings",
      section: "user",
      title: LocaleStrings.ticket_submenu_title6,
      description: LocaleStrings.ticket_submenu_description6,
    },
    {
      iconName: "wizard",
      section: "common",
      title: LocaleStrings.ticket_submenu_title9,
      description: LocaleStrings.ticket_submenu_description9,
    },
  ];
}
